module.exports = __webpack_public_path__ + "static/media/icon_radio_off.42d8b801.svg";